import Icon from '../components/Icon.vue'

Icon.register({
  utensils: {
    width: 416,
    height: 512,
    paths: [
      {
        d: 'M207.9 15.2C208.7 19.9 224 109.7 224 144 224 196.3 196.2 233.6 155.1 248.6L168 486.7C168.7 500.4 157.8 512 144 512H80C66.3 512 55.3 500.5 56 486.7L68.9 248.6C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3V157.5C65.3 160.9 79.1 160.7 80 157.5 81.4 132.2 87.9 18.3 88 15.7 91.3-5.1 132.7-5.1 135.9 15.7 136.1 18.4 142.5 132.2 143.9 157.5 144.8 160.7 158.7 160.9 159.9 157.5V16.3C162.5-5.3 204.7-5.1 207.9 15.2zM327.1 300.9L312.1 486C310.9 500 322 512 336 512H392C405.3 512 416 501.3 416 488V24C416 10.8 405.3 0 392 0 309.5 0 170.6 178.5 327.1 300.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/utensils.js
// module id = Xq0C
// module chunks = 144